import FileAudioIcon from './FileAudioIcon';
import FileCertifiedIcon from './FileCertifiedIcon';
import FileDocumentIcon from './FileDocumentIcon';
import FileFodFinIcon from './FileFodFinIcon';
import FileImageIcon from './FileImageIcon';
import FileNotaryIcon from './FileNotaryIcon';
import FileTextIcon from './FileTextIcon';
import FileThirdPartyIcon from './FileThirdPartyIcon';
import FileVideoIcon from './FileVideoIcon';
import FolderIcon from './FolderIcon';
import FolderLockedIcon from './FolderLockedIcon';

// extensions based on allowed file types from api
const imageExtensions = [
  'bmp',
  'dwg',
  'dxf',
  'emf',
  'gif',
  'jpg',
  'jpeg',
  'png',
  'heic',
  'tiff',
  'svg',
  'ai',
  'eps',
  'psd',
  'raw',
  'tif',
  'ttf',
  'vsd',
  'vsdx',
  'wmf',
];

const videoExtensions = ['avi', 'mov', 'mpeg', 'mpg'];
const audioExtensions = ['mp3', 'mp4', 'wav'];

export interface FileIconProps {
  color: string;
  extension?: string;
  size?: number;
}

interface Props extends FileIconProps {
  withNotaryIcon?: boolean;
  isFolder?: boolean;
  isThirdParty?: boolean;
  isCertified?: boolean;
  isLockedFolder?: boolean;
  withFodFinIcon?: boolean;
  isTextFile?: boolean;
}

const FileIcon = ({
  withNotaryIcon,
  isFolder,
  isThirdParty,
  isCertified,
  isLockedFolder,
  withFodFinIcon,
  isTextFile,
  ...props
}: Props) => {
  if (isLockedFolder) {
    return <FolderLockedIcon {...props} />;
  }
  if (isFolder) {
    return <FolderIcon {...props} />;
  }
  if (isCertified) {
    return <FileCertifiedIcon {...props} />;
  }
  if (isThirdParty) {
    return <FileThirdPartyIcon {...props} />;
  }
  if (withNotaryIcon) {
    return <FileNotaryIcon {...props} />;
  }
  if (withFodFinIcon) {
    return <FileFodFinIcon {...props} />;
  }
  if (isTextFile) {
    return <FileTextIcon {...props} />;
  }
  if (props.extension && imageExtensions.includes(props.extension)) {
    return <FileImageIcon {...props} />;
  }
  if (props.extension && videoExtensions.includes(props.extension)) {
    return <FileVideoIcon {...props} />;
  }
  if (props.extension && audioExtensions.includes(props.extension)) {
    return <FileAudioIcon {...props} />;
  }
  return <FileDocumentIcon {...props} />;
};

export default FileIcon;
